import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("E:/JING/03learn/learning-practice20260509/vue3-20220318/ai-chat/chat-nuxt-20260528/layouts/default.vue").then(m => m.default || m))
}